<template>
  <div class="app_main">
    <div class="banner">
      <picture>
        <source
          media="(max-width: 768px)"
          srcset="@/assets/images/index/banner_m.png"
        />
        <img src="@/assets/images/index/banner.png" alt="豫知科技" />
      </picture>
      <!-- <div class="banner_des">
        <p>致力于提升我国医源性感染科室的感染风控能力</p>
        <p class="banner_des_sub">
          从科室环境到操作流程全方位进行监测、预警，形成可追溯的科学预防评价措施，降低医源性感染发病率。
        </p>
      </div> -->
    </div>
    <div class="risk">
      <div class="title"></div>
      <div class="base_layout">
        <div class="row">
          <div class="col-md-6 risk_box">
            <div class="icon icon_1">
              <!-- <img src="@/assets/images/index/risk_icon_1.png" alt="" /> -->
            </div>
            <div class="content">
              <h3>实时数据上报</h3>
              <dl>
                <dt>风险上报</dt>
                <dd>感控设备实时监测</dd>
                <dd>各岗位操作结果填报</dd>
              </dl>
            </div>
          </div>
          <div class="col-md-6 risk_box">
            <div class="icon icon_2">
              <!-- <img src="@/assets/images/index/risk_icon_2.png" alt="" /> -->
            </div>
            <div class="content">
              <h3>风险事件识别</h3>
              <dl>
                <dt>风险识别</dt>
                <dd>风险评估模型</dd>
                <dd>标准操作规程</dd>
              </dl>
            </div>
          </div>
          <div class="col-md-6 risk_box">
            <div class="icon icon_3">
              <!-- <img src="@/assets/images/index/risk_icon_1.png" alt="" /> -->
            </div>
            <div class="content">
              <h3>风险事件处置</h3>
              <dl>
                <dt>风险处置</dt>
                <dd>风险事件处置流程</dd>
                <dd>风险事件预警</dd>
              </dl>
            </div>
          </div>
          <div class="col-md-6 risk_box">
            <div class="icon icon_4">
              <!-- <img src="@/assets/images/index/risk_icon_4.png" alt="" /> -->
            </div>
            <div class="content">
              <h3>多维度风控报告</h3>
              <dl>
                <dt>风险报告</dt>
                <dd>多维度风控报表</dd>
                <dd>风控事件库</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="business">
      <div class="base_layout tabs_heitht">
        <ul class="tabs">
          <li class="tab tab_active">医疗感染风险监测整体解决方案</li>
          <li class="tab">新概念套箱式洁净手术室整体解决方案</li>
        </ul>
      </div>
      <div class="business_layout">
        <ul class="contents base_layout">
          <li class="tab_content show">
            <h3 class="tab_1">院感平台业务流程</h3>
            <h4 class="tab_1">
              以实时数据采集为基础，以大数据分析为核心对医院感染科室设备和操作流程进行监测、预警及追溯
            </h4>
            <div class="steps">
              <div
                class="step wow animate__animated animate__fadeInLeft"
                data-wow-delay="1s"
                data-wow-duration="1.2s"
              >
                <p class="icon icon_1"></p>
                <p class="step_title">数据采集</p>
                <p class="content">
                  Step.1：通过物联网技术实时采集医疗感染相关数据。
                </p>
              </div>
              <div
                class="step wow animate__animated animate__fadeInLeft"
                data-wow-delay="0.9s"
                data-wow-duration="1.2s"
              >
                <p class="icon icon_2"></p>
                <p class="step_title">逻辑分析</p>
                <p class="content">
                  Step.2：经过数据统计、风险评估模型等进行分析整理。
                </p>
              </div>
              <div
                class="step wow animate__animated animate__fadeInLeft"
                data-wow-delay="0.8s"
                data-wow-duration="1.2s"
              >
                <p class="icon icon_3"></p>
                <p class="step_title">标准规程</p>
                <p class="content">
                  Step.3：将数据模型分析的实际结果与标准操作规程进行对比。
                </p>
              </div>
              <div
                class="step wow animate__animated animate__fadeInLeft"
                data-wow-delay="0.7s"
                data-wow-duration="1.2s"
              >
                <p class="icon icon_4"></p>
                <p class="step_title">合理改进</p>
                <p class="content">
                  Step.4：针对医院感染风险对比结论，提供合理改进建议。
                </p>
              </div>
              <div
                class="step wow animate__animated animate__fadeInLeft"
                data-wow-delay="0.6s"
                data-wow-duration="1.2s"
              >
                <p class="icon icon_5"></p>
                <p class="step_title">降低感染</p>
                <p class="content">
                  Step.5：持续进行优化改进，从而有效降低医院感染发生率。
                </p>
              </div>
            </div>
          </li>
          <li class="tab_content tab_2">
            <div
              class="tab_left wow animate__animated animate__fadeInLeft"
              data-wow-delay="0.5s"
              data-wow-duration="1.2s"
            >
              <div class="tab_2_h">
                <p class="tab_2_t">维持30多年不变<br />经典的洁净手术室</p>
                <p class="tab_en">
                  THE CLASSIC CLEAN OPERATING <br />
                  ROOM THAT HAS REMAINED<br />
                  UNCHANGED FOR MORE THAN 30 YEARS
                </p>
              </div>
              <div class="tab_2_c">
                <p class="tab_c_t">执行标准</p>
                <p class="tab_en">IMPLEMENTATION STANDARD</p>
                <p class="tab_c_des">
                  <span> 1、</span>《医院洁净手术部建筑技术规范》GB50333-2013
                </p>
              </div>
              <div class="tab_2_c">
                <p class="tab_c_t">标准执行情况</p>
                <p class="tab_en">IMPLEMENTATION OF STANDARDS</p>
                <p class="tab_c_des">
                  <span> 2、</span>各项参数高于国家验收指标
                </p>
              </div>
              <div class="tab_2_c">
                <p class="tab_c_t">专业装饰装修造价</p>
                <p class="tab_en">
                  COST OF PROFESSIONAL DECORATION AND FITMENT
                </p>
                <p class="tab_c_des">
                  <span> 3、</span>经典洁净手术室与套箱式洁净手术室造价相同
                </p>
              </div>
            </div>
            <div
              class="tab_right wow animate__animated animate__fadeInRight"
              data-wow-delay="1s"
              data-wow-duration="1.2s"
            >
              <img src="@/assets/images/index/business_tab_2.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="characteristic">
      <div class="title"></div>
      <div
        class="characteristic_list wow animate__animated animate__fadeInUpBig"
        data-wow-delay="0.8s"
        data-wow-duration="1.2s"
      >
        <div class="item">
          <picture>
            <source
              media="(max-width: 768px)"
              srcset="@/assets/images/index/characteristic_m_1.png"
            />
            <img src="@/assets/images/index/characteristic_1.png" alt="" />
          </picture>

          <div class="item_content">
            <p class="text">
              医院感染病例监测<br /><span>发病率、现患率监测</span>
            </p>
          </div>
        </div>
        <div class="item">
          <picture>
            <source
              media="(max-width: 768px)"
              srcset="@/assets/images/index/characteristic_m_2.png"
            />
            <img src="@/assets/images/index/characteristic_2.png" alt="" />
          </picture>
          <div class="item_content">
            <p class="text">消毒灭菌效果监测<br /><span>确保灭菌效果</span></p>
          </div>
        </div>
        <div class="item">
          <picture>
            <source
              media="(max-width: 768px)"
              srcset="@/assets/images/index/characteristic_m_3.png"
            />
            <img src="@/assets/images/index/characteristic_3.png" alt="" />
          </picture>
          <div class="item_content">
            <p class="text">
              环境卫生学监测<br /><span>空气，物体表面的监测</span>
            </p>
          </div>
        </div>
        <div class="item">
          <picture>
            <source
              media="(max-width: 768px)"
              srcset="@/assets/images/index/characteristic_m_4.png"
            />
            <img src="@/assets/images/index/characteristic_4.png" alt="" />
          </picture>
          <div class="item_content">
            <p class="text">
              标准操作规程执行监测<br /><span>日常抽查和定期检查相结合</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="industry">
      <div class="title"></div>
      <div class="industry_layout">
        <picture>
          <source
            media="(max-width: 768px)"
            srcset="@/assets/images/index/industry_1@2x.png"
          />
          <img
            src="@/assets/images/index/industry_1.png"
            class="wow animate__animated animate__fadeInUpBig"
            data-wow-delay="1s"
            data-wow-duration="1.2s"
            alt=""
          />
        </picture>
      </div>
    </div>
    <div class="cooperate">
      <div class="title"></div>
      <div class="base_layout">
        <div class="row">
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_1.png" alt="" /></p>
            <p class="name">牡丹江林业中心医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_2.png" alt="" /></p>
            <p class="name">牡丹江市第一人民医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_3.png" alt="" /></p>
            <p class="name">牡丹江市妇幼保健院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_4.png" alt="" /></p>
            <p class="name">牡丹江市康安医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_5.png" alt="" /></p>
            <p class="name">牡丹江市肿瘤医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_6.png" alt="" /></p>
            <p class="name">牡丹江心血管病医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_7.png" alt="" /></p>
            <p class="name">牡丹江医学院第二附属医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_8.png" alt="" /></p>
            <p class="name">牡丹江医学院附属红旗医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_9.png" alt="" /></p>
            <p class="name">黑龙江省牡丹江南山医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_10.png" alt="" /></p>
            <p class="name">牡丹江现代泌尿医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_11.png" alt="" /></p>
            <p class="name">牡丹江市中医医院</p>
          </div>
          <div class="col-md-2 col-xs-4">
            <p><img src="@/assets/images/index/cooperate_12.png" alt="" /></p>
            <p class="name">牡丹江市仁和医院</p>
          </div>
        </div>
      </div>
    </div>
    <div class="patent">
      <div class="title"></div>
      <div class="t_b1k4ul swiper">
        <div class="swiper-wrapper">
          <div
            class="t_b1k4li swiper-slide"
            @click="imgBox(require('@/assets/images/index/patent_1@2x.png'))"
          >
            <div class="t_b1k4xin">
              <div class="t_b1k4bg">
                <img src="@/assets/images/index/patent_bg.png" alt="" />
              </div>
              <div class="t_b1k4pic ys_imgbox_cover">
                <img
                  src="@/assets/images/index/patent_1.png"
                  alt="patent_1.png"
                />
              </div>
            </div>
          </div>
          <div
            class="t_b1k4li swiper-slide"
            @click="imgBox(require('@/assets/images/index/patent_2@2x.png'))"
          >
            <div class="t_b1k4xin">
              <div class="t_b1k4bg">
                <img src="@/assets/images/index/patent_bg.png" alt="" />
              </div>
              <div class="t_b1k4pic ys_imgbox_cover">
                <img
                  src="@/assets/images/index/patent_2.png"
                  alt="patent_2.png"
                />
              </div>
            </div>
          </div>
          <div
            class="t_b1k4li swiper-slide"
            @click="imgBox(require('@/assets/images/index/patent_3@2x.png'))"
          >
            <div class="t_b1k4xin">
              <div class="t_b1k4bg">
                <img src="@/assets/images/index/patent_bg.png" alt="" />
              </div>
              <div class="t_b1k4pic ys_imgbox_cover">
                <img
                  src="@/assets/images/index/patent_3.png"
                  alt="patent_3.png"
                />
              </div>
            </div>
          </div>
          <div
            class="t_b1k4li swiper-slide"
            @click="imgBox(require('@/assets/images/index/patent_4@2x.png'))"
          >
            <div class="t_b1k4xin">
              <div class="t_b1k4bg">
                <img src="@/assets/images/index/patent_bg.png" alt="" />
              </div>
              <div class="t_b1k4pic ys_imgbox_cover">
                <img
                  src="@/assets/images/index/patent_4.png"
                  alt="patent_4.png"
                />
              </div>
            </div>
          </div>
          <div
            class="t_b1k4li swiper-slide"
            @click="imgBox(require('@/assets/images/index/patent_5@2x.png'))"
          >
            <div class="t_b1k4xin">
              <div class="t_b1k4bg">
                <img src="@/assets/images/index/patent_bg.png" alt="" />
              </div>
              <div class="t_b1k4pic ys_imgbox_cover">
                <img
                  src="@/assets/images/index/patent_5.png"
                  alt="patent_5.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="t_b1k4qie">
          <div class="t_b1k4huan swiper-button-prev">
            <!-- <img src="@/assets/images/index/button-prev.png" alt="" /> -->
          </div>
          <div class="t_b1k4huan swiper-button-next">
            <!-- <img src="@/assets/images/index/button-next.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
    <el-drawer :visible.sync="drawer" :withHeader="false" direction="ttb">
      <div class="imgbox">
        <img :src="imgurl" alt="patent_1.png" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import "@/styles/swiper.min.css";
import Swiper from "@/utils/swiper.min.js";
import "@/utils/wow.js";
export default {
  data() {
    return {
      drawer: false,
      imgurl: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });

    $(".tabs .tab").click(function () {
      $(this).addClass("tab_active").siblings().removeClass("tab_active");
      let id = $(this).index();
      let pos = id == 0 ? 0 : 200;
      $(".tabs").animate({ scrollLeft: pos }, "slow");
      $(".contents .tab_content")
        .eq(id)
        .addClass("show")
        .siblings()
        .removeClass("show");
    });

    new Swiper(".t_b1k4ul", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      initialSlide: 0,
      loopedSlides: 5,
      slideToClickedSlide: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        progress: function (progress) {
          for (let i = 0; i < this.slides.length; i++) {
            let slide = this.slides.eq(i);
            let slideProgress = this.slides[i].progress;
            let modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.001 + 1;
            }
            let translate = slideProgress * modify * 194 + "px";
            let scale = 1 - Math.abs(slideProgress) / 15;
            let zIndex = 999 - Math.abs(Math.round(15 * slideProgress));
            slide.transform(
              "translateX(" + translate + ") scale(" + scale + ")"
            );
            slide.css("zIndex", zIndex);
            slide.css("opacity", 1);
            if (Math.abs(slideProgress) > 2) {
              slide.css("opacity", 0);
            }
          }
        },
        setTransition: function (transition) {
          for (let i = 0; i < this.slides.length; i++) {
            let slide = this.slides.eq(i);
            slide.transition(transition);
          }
        },
      },
    });
  },
  methods: {
    imgBox(url) {
      this.drawer = true;
      this.imgurl = url;
    },
  },
};
</script>
<style scoped></style>
